// @flow

import React, { Component } from 'react';
import './SubMenu.scss';
import { Link } from 'react-router-dom';
import { sanitizePlainText, sanitizeUrl } from '../../utils/sanitize';

class SubMenu extends Component {
  openSafeLink = url => {
    const safeUrl = sanitizeUrl(url);
    if (safeUrl) {
      window.open(safeUrl, '_blank', 'noopener,noreferrer');
    }
  };

  render() {
    return (
      <div
        className={
          'submenu__wrapper ' +
          (this.props.buttonHovered === this.props.menu.id ? 'active' : '')
        }
      >
        {this.props.menu.submenu &&
            <div className="submenu__column">
              <ul className="submenu__links">
                {this.props.menu.submenu.map(link =>
                    link.target ? (
                      <li key={link.id} className="submenu__link">
                        <a
                          onClick={() => {
                            this.props.closeMenu();
                            this.openSafeLink(link.url);
                          }}
                          className="title-item-asd"
                        >
                          {sanitizePlainText(link.name)}
                        </a>
                      </li>
                    ) : (
                      <li key={link.id} className="submenu__link">
                        <Link
                          to={link.url}
                          onClick={() => this.props.closeMenu()}
                        >
                          <span> {sanitizePlainText(link.name)} </span>
                        </Link>
                      </li>
                    )
                  )}
              </ul>
            </div>
          }
      </div>
    );
  }
}

export default SubMenu;
